module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "gr-6 gr-12@xs gr-6@md"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.usernameClass
  }, [_c('float-label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.username),
      expression: "username",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-group__input",
    attrs: {
      "autofocus": "",
      "placeholder": "username",
      "type": "text",
      "name": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value.trim()
      }, function($event) {
        return _vm.checkField('username', $event)
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _c('i', {
    staticClass: "form-group__icon"
  })])], 1)]), _c('div', {
    staticClass: "gr-6 gr-12@xs gr-6@md"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.passwordClass
  }, [_c('float-label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-group__input",
    attrs: {
      "autocomplete": "false",
      "placeholder": "password",
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }, function($event) {
        return _vm.checkField('password', $event)
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _c('i', {
    staticClass: "form-group__icon"
  })])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b732115","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/login.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7b732115","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/login.vue
// module chunks = 0